export class ScrollUtil {
    private static readonly lastBrowseLocationKey = 'lastBrowseLocation';

    public static saveLastBrowseLocation = (location: string) => {
        sessionStorage.setItem(this.lastBrowseLocationKey, location);
    };

    public static getLastBrowseLocation = (): string | null => {
        return sessionStorage.getItem(this.lastBrowseLocationKey);
    };
}
